import { render, staticRenderFns } from "./CanceledList.vue?vue&type=template&id=b39a20de&scoped=true&"
import script from "./CanceledList.vue?vue&type=script&lang=js&"
export * from "./CanceledList.vue?vue&type=script&lang=js&"
import style0 from "./CanceledList.vue?vue&type=style&index=0&id=b39a20de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39a20de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39a20de')) {
      api.createRecord('b39a20de', component.options)
    } else {
      api.reload('b39a20de', component.options)
    }
    module.hot.accept("./CanceledList.vue?vue&type=template&id=b39a20de&scoped=true&", function () {
      api.rerender('b39a20de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/CanceledList.vue"
export default component.exports